import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import { socket } from 'api';
import { Place, PlaceItem } from './regular-options-checkbox.styled';

export const RegularOptionsCheckbox = (props) => {
  const { t } = useTranslation();
  const { zoneId, zone } = props;
  const [loading, setLoading] = useState(true);

  const updateState = () => {
    socket.call('get_zones_status');
  };

  const onGetState = (_msg) => {
    setLoading(false);
    // const out = {};
    // msg.zones.forEach((el) => (out[el.zone_id] = el));
    // setZones(out);
  };

  useEffect(() => {
    window.socket.on('set_zone_status', updateState);
    window.socket.on('get_zones_status', onGetState);
    // updateState();
    return () => {
      window.socket.off('set_zone_status', updateState);
      window.socket.off('get_zones_status', onGetState);
    };
  }, []);

  if (!zone) {
    return null;
  }

  const setOption = (event) => {
    const val = event.target.checked;
    setLoading(true);
    socket.call('set_zone_regular_only', { zone_id: zoneId, regular_only: val });
  };

  const checked = zone.regular_only;
  // const checked = zones[zoneId] ? zones[zoneId].regular_only : false;
  
  return (
    <Place loading={loading}>
      <PlaceItem>
        <input type="checkbox" id="regularcheckbox" checked={checked} onChange={setOption} />
        <label htmlFor="regularcheckbox">{t('checkboxes.Запретить въезд разовым клиентам')}</label>
      </PlaceItem>
    </Place>
  );
};

RegularOptionsCheckbox.propTypes = {
  zoneId: PropTypes.any.isRequired,
};
